import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, SelectInput, TextInput } from '../Form';
import { timezones } from '../../libs/date';

@inject('dataOriginStore', 'dataSourceStore', 'dataOriginParameterTemplateStore')
@observer
class DataSourceOriginAdd extends Component {
  static contextTypes = {
    router: PropTypes.shape().isRequired,
    notify: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug;
  @observable dataOrigin = {
    data_source_id: 0,
    code: '',
    timezone: '',
    parameterTemplate: ''
  };

  title = 'Add Data Origin';

  constructor(props) {
    super(props);
    this.init();
  }


  componentWillMount() {
    const { dataOriginParameterTemplateStore } = this.props;
    if (!dataOriginParameterTemplateStore.items.length) dataOriginParameterTemplateStore.fetchItems();
  }


  @action init = () => {
    const { params: { id } } = this.props;
    this.slug = `/daq/data-source/${id}/data-origin`;
    this.dataOrigin.data_source_id = id;
  }

  @action onChangeCode = (e) => { this.dataOrigin.code = e.target.value; }
  @action onChangeTimezone = (e) => { this.dataOrigin.timezone = e.target.value; }
  @action onChangeParameterTemplate = e => this.dataOrigin.parameterTemplate = e.target.value;

  @action handleSave = (e) => {
    e.preventDefault();

    const { notify, router } = this.context;
    const { dataSourceStore, dataOriginStore, params: { id } } = this.props;
    dataOriginStore
      .createItem(this.dataOrigin)
      .then((res) => {
        dataSourceStore.items.filter(ds => ds.id == id)[0].origins.push(Object.assign({}, res, { data_origin_parameters: [] }));

        // this.dataOrigin.id = res.filter(dOrigin => dOrigin.code == this.dataOrigin.code && dOrigin.timezone == this.dataOrigin.timezone)[0].id;
        // this.dataOrigin.data_origin_parameters = [];
        // dataSourceStore.items.filter(ds => ds.id == id)[0].origins.push(this.dataOrigin);
        router.push(this.slug);
        notify.success({ message: 'Created Data Origin' });
      })
      .catch((err) => {
        notify.error({ message: err.message || err.toString() });
      });
  };

  render() {
    const { params: { id }, dataOriginStore, dataOriginParameterTemplateStore } = this.props;

    if (dataOriginStore.isLoading) { return <Spinner />; }

    return (
      <Modal title={this.title} slug={this.slug} isSaving={dataOriginStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            <TextInput label={'Code'} value={this.dataOrigin.code} onChange={this.onChangeCode} />

            <SelectInput
              label={'Timezone'}
              fields={{ label: 'offset', value: 'offset' }}
              options={timezones}
              onChange={this.onChangeTimezone}
              value={this.dataOrigin.timezone}
            />

            <SelectInput
              label={'Parameter Template'}
              fields={{ label: 'name', value: 'id' }}
              options={dataOriginParameterTemplateStore.items}
              onChange={this.onChangeParameterTemplate}
              value={this.dataOrigin.parameterTemplate}
            />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}

export default DataSourceOriginAdd;



// WEBPACK FOOTER //
// ./src/components/DataSource/DataSourceOriginAdd.js